<template>
    <div>
        <div class="container">
            <br />
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">My Big Enterprise</h1>
                </div>
                <div class="col-lg-3">
                    <img src="https://www.transparentchoice.com/hubfs/Transparent%20Choice%202021/Home%20Page/Header%20logo.svg" />
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="row" style="margin-bottom: 40px;">
                <div class="col">
                    <div class="card bg-light">
                        <div class="card-body">
                            <h5 class="card-title">Welcome guest</h5>
                            <p class="card-text">If you don't have an account then you can request one from this page, bla bla bla.</p>
                            <a :href="`/#/organizations/users/requestaccount/${token}`" class="btn btn-primary btn-lg btn-block">Request an account</a>
                        </div>
                    </div>
                    <br />

                    <div class="card bg-light">
                        <div class="card-body">
                            <h5 class="card-title">Support</h5>
                            <h6 class="card-subtitle mb-2 text-muted">In house: support@mybigenterprise.com</h6>
                            <h6 class="card-subtitle mb-2 text-muted">Vendor: support@transparentchoice.com</h6>
                            <p class="card-text">In troubles or have some questions please contact support.</p>
                            <button type="button" class="btn btn-secondary btn-lg btn-block">Send ticket</button>
                        </div>
                    </div>
                    <br />

                    <div class="card bg-light">
                        <div class="card-body">
                            <h5 class="card-title">FAQ</h5>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">Cras justo odio</li>
                                <li class="list-group-item">Dapibus ac facilisis in</li>
                                <li class="list-group-item">Vestibulum at eros</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>

                <div class="col">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus malesuada enim sit amet urna sollicitudin, vitae condimentum lorem ultricies. Ut suscipit posuere arcu et cursus. Nullam elit felis, fringilla sed imperdiet sed, varius vitae urna. Sed consectetur, dolor in finibus eleifend, odio quam pharetra mauris, ut dapibus eros dolor id dolor. Nunc dignissim ultrices rutrum. Mauris quis sapien in nibh vehicula laoreet. Nullam risus nulla, porttitor eu odio vitae, ultricies laoreet ex. Mauris ultricies varius laoreet.
                    Etiam in tincidunt sapien. Praesent blandit nisi sit amet nunc mollis, in sollicitudin est ultrices. Fusce molestie auctor odio vel feugiat. Phasellus vel pellentesque sem. Pellentesque in mauris sit amet turpis scelerisque faucibus. Proin sed lorem aliquam, congue tortor eget, dignissim metus. Morbi laoreet massa in viverra accumsan. Curabitur mauris ex, pretium ac velit vel, finibus gravida ante. Donec metus sem, porttitor a ex et, ultrices fringilla quam. Aliquam tempus, libero eu rhoncus blandit, purus orci semper nibh, pharetra condimentum neque odio ac eros. Aliquam a tellus in ante scelerisque consectetur at sit amet lacus. Etiam pharetra mauris ipsum, in vulputate nibh viverra vel.
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";

    @Component
    export default class DashboardPage extends mixins(PageBase) {
        get token(): string { return this.$route.params.token; }
    }
</script>

<style scoped>
</style>